import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5697238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "titre" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "sendCodeDescription" }
const _hoisted_5 = { class: "email-validation" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "code-section"
}
const _hoisted_10 = { for: "emailCode" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "email-error"
}
const _hoisted_13 = {
  key: 2,
  class: "email-success"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("form", { id: "payment-form" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "card-container" })
], -1))
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "total-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Requestbox = _resolveComponent("Requestbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InformationFrom = _resolveComponent("InformationFrom")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TotalBox = _resolveComponent("TotalBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('confirmationCommande')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          title: _ctx.$t('boitesDemandees')
        }, {
          content: _withCtx(() => [
            _createVNode(_component_Requestbox)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('infosEnvoi')
        }, {
          content: _withCtx(() => [
            _createVNode(_component_router_link, { to: { name: 'profil' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('consigneInfosProfil')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_InformationFrom, {
              class: "informationFrom",
              distribution: _ctx.distribution,
              "onUpdate:distribution": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.distribution) = $event)),
              onInterface: _ctx.getInfoFormInterface
            }, null, 8, ["distribution", "onInterface"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('validationEmail')
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('sendCodeDescription')), 1),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.emailValidated)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendEmailCode && _ctx.sendEmailCode(...args))),
                    disabled: (_ctx.codeSent && _ctx.resendTimer > 0) || _ctx.emailValidated,
                    class: "btn-send-code btn-demande"
                  }, [
                    (!_ctx.codeSent || _ctx.resendTimer === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('sendCode')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('sendCode')) + " (" + _toDisplayString(_ctx.resendTimer) + ")", 1))
                  ], 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.codeSent && !_ctx.emailValidated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('enterCode')), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "emailCode",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailCode) = $event)),
                      class: "input-code"
                    }, null, 512), [
                      [_vModelText, _ctx.emailCode]
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateEmailCode && _ctx.validateEmailCode(...args))),
                      disabled: !_ctx.emailCode,
                      class: "btn-validate-code btn-demande"
                    }, _toDisplayString(_ctx.$t('validateCode')), 9, _hoisted_11),
                    (_ctx.emailError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.emailError), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.emailValidated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('emailValidated')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _withDirectives(_createVNode(_component_Card, {
          title: _ctx.$t('methodePaiement')
        }, {
          content: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["title"]), [
          [_vShow, _ctx.totalPrice > 0]
        ]),
        (_ctx.errorCommand)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.loading || !_ctx.emailValidated || _ctx.distribution == null || _ctx.distribution == -1,
          class: "btn-demande",
          ref: "cardButton"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'box-circle-check'] }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('boutons.passerCommande')), 1)
        ], 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(), _createBlock(_component_TotalBox, {
          key: _ctx.totalPrice,
          totalPrice: _ctx.totalPrice
        }, null, 8, ["totalPrice"]))
      ])
    ])
  ], 64))
}